import React from 'react';
import { useTranslation, i18n } from '@lt/localization';
import { LT_PHONE_NUMBER } from '../../../../../../constants/common';

const text = i18n.t('checkout.flight.noResults.text');

const FlightsNoResults = () => {
  const { t } = useTranslation();
  return (
    <div className="checkout-flights__no-results">
      <div className="like-h2">{t('checkout.flight.noResults.title')}</div>
      <p>
        {text}
        <br />
        <strong>{LT_PHONE_NUMBER}</strong>
      </p>
    </div>
  );
};

export default FlightsNoResults;
